import axios from 'axios'
import library from '../../../utils/Library'

export const getApplicationInstance = async (instanceId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') + '/getApplicationInstanceEAuthz'

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      applicationInstanceId: instanceId
    }
  })
}
